(function(){
'use strict';
/* CustoTag LP v5 (16-10-26). One page, both phones. Cart mechanics are v3's (ct-ios-v3-lp.js);
   what is new: the phone and language switches, the payment line, line-item tags for the v3/v5 read.
   Phone + door are decided by the inline script in page.custotag-v5.liquid before this runs;
   this file only reads them from #ct-lp-v5 and changes them when the visitor switches. */
const ROOT=document.getElementById('ct-lp-v5');
if(!ROOT)return;

/* Fallback ladders. #ct-v5-data (live Shopify) overrides price/mrp by variant id. */
const LADDER={
  ios:[
    {qty:1,price:679,mrp:1999,variantId:47850416242907},
    {qty:2,price:1249,mrp:3998,variantId:47850419683547},
    {qty:3,price:1799,mrp:5997,variantId:47850420535515},
    {qty:4,price:2299,mrp:7996,variantId:47850420568283},
    {qty:6,price:3299,mrp:11994,variantId:47850420666587},
    {qty:8,price:3999,mrp:15992,variantId:48039760789723}
  ],
  and:[
    {qty:1,price:799,mrp:1999,variantId:48226460893403},
    {qty:2,price:1499,mrp:3998,variantId:48226501329115},
    {qty:3,price:2149,mrp:5997,variantId:48226506899675},
    {qty:4,price:2749,mrp:7996,variantId:48226507751643},
    {qty:6,price:3699,mrp:11994,variantId:48226509750491},
    {qty:8,price:4599,mrp:15992,variantId:48226513289435}
  ]
};
const STOCK={ios:{oos:false,preorder:false,ship:'',back:''},and:{oos:false,preorder:false,ship:'',back:''}};
(function syncLive(){
  try{
    const d=JSON.parse(document.getElementById('ct-v5-data').textContent);
    ['ios','and'].forEach(os=>{
      const o=d[os];if(!o)return;
      const byId={};(o.rows||[]).forEach(r=>{byId[r.vid]=r;});
      LADDER[os].forEach(p=>{const r=byId[p.variantId];if(r&&r.price>0){p.price=r.price;if(r.mrp>p.price)p.mrp=r.mrp;}});
      STOCK[os]={oos:!!o.oos,preorder:!!o.preorder,ship:o.ship||'',back:o.back||''};
    });
  }catch(e){}
})();

/* COD fee by cart total (Rohan, 16.10.26). Above the last tier there is no COD and the page
   says nothing about payment: a buyer at that price pays online. */
const COD_TIERS=[{upTo:2000,fee:99},{upTo:3500,fee:149}];
const codFee=t=>{for(const x of COD_TIERS){if(t<=x.upTo)return x.fee;}return null;};

const SIL_COLORS=[
  {name:'Black',variantId:47851440308443,hex:'#1a1a1a',price:120},
  {name:'Navy Blue',variantId:47851440341211,hex:'#1e3a5f',price:120},
  {name:'White',variantId:47851440373979,hex:'#f0f0f0',price:120,border:true},
  {name:'Baby Pink',variantId:47851440406747,hex:'#f4a7b9',price:120}
];
const COL_COLORS=[
  {name:'Black',variantId:48163991650523,hex:'#1a1a1a',price:120},
  {name:'Sky Blue',variantId:48164004004059,hex:'#87CEEB',price:120},
  {name:'White',variantId:48163991716059,hex:'#f0f0f0',price:149,border:true},
  {name:'Baby Pink',variantId:48163991748827,hex:'#f4a7b9',price:149}
];
const BAT_VID=47851464163547,BAT_PRICE=350;
const CDN='https://cdn.shopify.com/s/files/1/0566/4840/1048/files/';
const IMGS={
  ios:['IOS_Custotag_1.jpg?v=1786450434','cti-lp-silicone-case-180926.jpg?v=1789730263','cti-lp-size-180926.jpg?v=1789730264','cti-lp-battery-subscription-180926.webp?v=1789730328','cti-lp-resetting-180926.webp?v=1789730328'],
  and:['CustoTag_Android_1.jpg?v=1777965022','CustoTag_Android_3.jpg?v=1770361488','CustoTag_Android_5.jpg?v=1770361488','CustoTag_Android_4.jpg?v=1770361488','CustoTag_Android_9.jpg?v=1770361488']
};
const NAME={ios:'CustoTag for iOS',and:'CustoTag for Android'};

let os=ROOT.dataset.os==='and'?'and':'ios';
let lang=ROOT.dataset.lang==='en'?'en':'hi';
let selected=0; /* 1 tag by default (spec 3.6) */
let silQtys=[0,0,0,0],colQtys=[0,0,0,0],bat={on:false,qty:1};
let cIdx=0,cTimer;
const fmt=n=>'₹'+n.toLocaleString('en-IN');
const perUnit=p=>Math.ceil(p.price/p.qty); /* ceil: never overstate the deal */
const pack=()=>LADDER[os][selected];
const $=id=>document.getElementById(id);

function setOS(next,byUser){
  if(next!=='ios'&&next!=='and')return;
  os=next;
  ROOT.setAttribute('data-os',os);
  if(byUser){
    ROOT.setAttribute('data-os-detected','1');
    try{sessionStorage.setItem('ct_os_pick',os);}catch(e){}
    try{const u=new URL(location.href);u.searchParams.set('os',os);history.replaceState(null,'',u);}catch(e){}
  }
  buildChips();buildCarousel();updateTotal();
}

function setLang(next){
  if(next!=='hi'&&next!=='en')return;
  lang=next;
  ROOT.setAttribute('data-lang',lang);ROOT.setAttribute('lang',lang==='en'?'en':'hi-Latn');
  try{sessionStorage.setItem('ct_lang',lang);}catch(e){}
  try{const u=new URL(location.href);u.searchParams.set('lang',lang);history.replaceState(null,'',u);}catch(e){}
  updateTotal();
}

function buildChips(){
  const el=$('ct-v5-pack-chips');if(!el)return;
  el.innerHTML=LADDER[os].map((p,i)=>`
    <button class="ct-v5-pack-chip${i===selected?' selected':''}" data-i="${i}" type="button" aria-pressed="${i===selected}">
      <span class="ct-v5-pack-chip-n">${p.qty} tag${p.qty>1?'s':''}</span>
      <span class="ct-v5-pack-chip-price">${fmt(p.price)}</span>
      <span class="ct-v5-pack-chip-per">${p.qty>1?fmt(perUnit(p))+'/tag':'&nbsp;'}</span>
    </button>`).join('');
  el.querySelectorAll('.ct-v5-pack-chip').forEach(c=>c.addEventListener('click',()=>{
    selected=+c.dataset.i;
    el.querySelectorAll('.ct-v5-pack-chip').forEach(x=>{x.classList.toggle('selected',x===c);x.setAttribute('aria-pressed',x===c);});
    updateTotal();
  }));
}

function buildColorGrid(gridId,colors,q){
  const el=$(gridId);if(!el)return;
  el.innerHTML=colors.map((c,i)=>`
    <div class="ct-v5-color-row${q[i]>0?' active':''}">
      <div class="ct-v5-color-dot" style="background:${c.hex}${c.border?';box-shadow:inset 0 0 0 1.5px #ccc':''}"></div>
      <span class="ct-v5-color-name">${c.name}</span>
      <span class="ct-v5-color-row-price">${fmt(c.price)}</span>
      <div class="ct-v5-color-qty-wrap">
        <button class="ct-v5-qty-btn" data-d="-1" data-i="${i}" type="button" aria-label="Remove one ${c.name}">&#8722;</button>
        <span class="ct-v5-qty-val">${q[i]}</span>
        <button class="ct-v5-qty-btn" data-d="1" data-i="${i}" type="button" aria-label="Add one ${c.name}">+</button>
      </div>
    </div>`).join('');
  el.querySelectorAll('.ct-v5-qty-btn').forEach(b=>b.addEventListener('click',()=>{
    const i=+b.dataset.i;q[i]=Math.max(0,q[i]+(+b.dataset.d));
    const row=b.closest('.ct-v5-color-row');row.querySelector('.ct-v5-qty-val').textContent=q[i];row.classList.toggle('active',q[i]>0);
    updateTotal();
  }));
}

function initBattery(){
  const ck=$('ct-v5-bat-check'),m=$('ct-v5-bat-minus'),p=$('ct-v5-bat-plus'),v=$('ct-v5-bat-qty');
  if(ck){
    const t=()=>{bat.on=!bat.on;ck.classList.toggle('checked',bat.on);ck.setAttribute('aria-checked',bat.on);
      ck.innerHTML=bat.on?'<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="2,8 6,12 14,4"/></svg>':'';updateTotal();};
    ck.addEventListener('click',t);
    ck.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();t();}});
  }
  m?.addEventListener('click',()=>{if(bat.qty>1){bat.qty--;v.textContent=bat.qty;updateTotal();}});
  p?.addEventListener('click',()=>{bat.qty++;v.textContent=bat.qty;updateTotal();});
}

function updateTotal(){
  const pk=pack(),st=STOCK[os];
  let total=pk.price;
  let rows=`<div class="ct-v5-order-row"><span>${NAME[os]} &times; ${pk.qty}</span><span>${fmt(pk.price)}</span></div>`;
  SIL_COLORS.forEach((c,i)=>{if(silQtys[i]>0){const t=c.price*silQtys[i];total+=t;rows+=`<div class="ct-v5-order-row"><span>Silicone Case, ${c.name} &times;${silQtys[i]}</span><span>${fmt(t)}</span></div>`;}});
  COL_COLORS.forEach((c,i)=>{if(colQtys[i]>0){const t=c.price*colQtys[i];total+=t;rows+=`<div class="ct-v5-order-row"><span>Collar Case, ${c.name} &times;${colQtys[i]}</span><span>${fmt(t)}</span></div>`;}});
  if(bat.on){const t=BAT_PRICE*bat.qty;total+=t;rows+=`<div class="ct-v5-order-row"><span>Battery Subscription &times;${bat.qty}</span><span>${fmt(t)}</span></div>`;}
  const extras=total>pk.price;
  rows+=`<div class="ct-v5-order-row total"><span>Total</span><span>${fmt(total)}</span></div>`;
  const sum=$('ct-v5-order-summary');if(sum){sum.innerHTML=extras?rows:'';sum.hidden=!extras;}

  const now=$('ct-v5-price-now'),mrp=$('ct-v5-price-mrp'),per=$('ct-v5-price-per');
  if(now)now.textContent=fmt(pk.price);
  if(mrp){mrp.textContent=pk.mrp?fmt(pk.mrp):'';mrp.style.display=pk.mrp?'':'none';}
  if(per)per.textContent=pk.qty>1?`${pk.qty} tags · ${fmt(perUnit(pk))} per tag`:(st.oos?'Pre-order opens '+st.back:st.preorder?'Ships from '+st.ship:'1 tag · Ships in 24 hours');

  const pay=$('ct-v5-pay-line'),fee=codFee(total);
  if(pay){
    if(fee===null||st.oos){pay.hidden=true;pay.innerHTML='';}
    else{pay.hidden=false;pay.innerHTML=lang==='en'
      ?`Pay online: <strong>no extra charge</strong> &middot; Cash on Delivery: <strong>${fmt(fee)} extra</strong>`
      :`Online pay: <strong>koi extra charge nahi</strong> &middot; Cash on Delivery: <strong>${fmt(fee)} extra</strong>`;}
  }

  const btns=[$('ct-v5-atc-btn'),$('ct-v5-sticky-atc-btn')].filter(Boolean);
  btns.forEach((b,i)=>{
    if(b.dataset.busy)return;
    b.disabled=st.oos;b.setAttribute('aria-disabled',st.oos);
    b.classList.toggle('ct-v5-atc-oos',st.oos);
    b.innerHTML=st.oos?'Out of Stock':(st.preorder?'Pre-order':'Add to Cart')+(i===0?' &middot; '+fmt(total):'');
  });
  const sl=$('ct-v5-sticky-atc-label'),sp=$('ct-v5-sticky-atc-price');
  if(sl)sl.textContent=`${pk.qty} tag${pk.qty>1?'s':''} · ${os==='ios'?'iPhone':'Android'}`;
  if(sp)sp.textContent=fmt(total);
}

function toast(msg){
  let t=$('ct-v5-toast');
  if(!t){t=document.createElement('div');t.id='ct-v5-toast';t.className='ct-v5-toast';t.setAttribute('role','status');document.body.appendChild(t);}
  t.innerHTML=msg;t.classList.add('show');setTimeout(()=>t.classList.remove('show'),4500);
}

/* Same drawer-open as v3 (see the long note in ct-ios-v3-lp.js). */
function openCartDrawer(){
  const mp=document.querySelector('modal-popup[enable-cart]');const cart=mp&&mp.cartContent;
  if(cart&&typeof cart.update==='function'){try{cart.update(function(){});}catch(e){}}
  const tg=document.querySelector('modal-trigger[target="CART"]')||document.querySelector('[data-cart-toggle],[data-drawer-toggle="cart"],#CartToggle,.js-cart-open,[aria-label="Cart"]');
  if(tg&&cart){tg.click();return true;}return false;
}

/* The pack line carries hidden (underscore) properties so orders can be read by page, phone
   and door: _lp=v5 is the v5 arm of the v3/v5 test (spec section 4). */
async function addToCart(){
  const btns=[$('ct-v5-atc-btn'),$('ct-v5-sticky-atc-btn')].filter(Boolean);
  if(!btns.length||btns[0].disabled||STOCK[os].oos)return;
  btns.forEach(b=>{b.dataset.busy='1';b.disabled=true;b.textContent='Adding...';});
  const items=[{id:pack().variantId,quantity:1,properties:{_lp:'v5',_lp_os:os,_lp_door:ROOT.dataset.door||'default',_lp_lang:lang}}];
  SIL_COLORS.forEach((c,i)=>{if(silQtys[i]>0)items.push({id:c.variantId,quantity:silQtys[i]});});
  COL_COLORS.forEach((c,i)=>{if(colQtys[i]>0)items.push({id:c.variantId,quantity:colQtys[i]});});
  if(bat.on)items.push({id:BAT_VID,quantity:bat.qty});
  try{
    const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
    if(!r.ok)throw new Error(String(r.status));
    document.dispatchEvent(new CustomEvent('cart:updated'));document.dispatchEvent(new CustomEvent('cart:added'));
    openCartDrawer();
    toast('Added to cart! <a href="/cart">View Cart &rarr;</a>');
  }catch(e){toast('Something went wrong. Please try again.');}
  finally{btns.forEach(b=>{delete b.dataset.busy;b.disabled=false;});updateTotal();}
}

function buildCarousel(){
  const track=$('ct-v5-carousel-track'),dots=$('ct-v5-carousel-dots');if(!track||!dots)return;
  const list=IMGS[os];cIdx=0;clearInterval(cTimer);
  track.style.transform='translateX(0)';
  track.innerHTML=list.map((f,i)=>`<div class="ct-v5-carousel-slide"><img src="${CDN}${f}&width=800" alt="${NAME[os]}" loading="${i===0?'eager':'lazy'}" width="800" height="800"></div>`).join('');
  dots.innerHTML=list.map((_,i)=>`<button class="ct-v5-carousel-dot${i===0?' active':''}" data-i="${i}" aria-label="Slide ${i+1}" type="button"></button>`).join('');
  dots.querySelectorAll('.ct-v5-carousel-dot').forEach(d=>d.addEventListener('click',()=>goTo(+d.dataset.i)));
  startAuto();
}
function goTo(i){
  const n=IMGS[os].length;cIdx=(i+n)%n;
  const track=$('ct-v5-carousel-track');if(track)track.style.transform=`translateX(-${cIdx*100}%)`;
  document.querySelectorAll('.ct-v5-carousel-dot').forEach((d,j)=>d.classList.toggle('active',j===cIdx));
  clearInterval(cTimer);startAuto();
}
function startAuto(){cTimer=setInterval(()=>goTo(cIdx+1),3500);}
function initCarouselControls(){
  $('ct-v5-carousel-prev')?.addEventListener('click',()=>goTo(cIdx-1));
  $('ct-v5-carousel-next')?.addEventListener('click',()=>goTo(cIdx+1));
  const track=$('ct-v5-carousel-track');let x0=0;
  track?.addEventListener('touchstart',e=>{x0=e.touches[0].clientX;},{passive:true});
  track?.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40)goTo(cIdx+(dx<0?1:-1));});
}

function initFAQ(){
  ROOT.querySelectorAll('.ct-v5-faq-item').forEach(item=>{
    item.querySelector('.ct-v5-faq-q')?.addEventListener('click',()=>{
      const open=item.classList.contains('open');
      ROOT.querySelectorAll('.ct-v5-faq-item.open').forEach(i=>i.classList.remove('open'));
      if(!open)item.classList.add('open');
    });
  });
}

function initModal(){
  const ov=$('ct-v5-modal'),v=$('ct-v5-modal-video');
  const close=()=>{ov?.classList.remove('open');if(v){v.pause();v.currentTime=0;}};
  ROOT.querySelectorAll('[data-open-video]').forEach(b=>b.addEventListener('click',()=>{
    if(v){const src=v.dataset['src'+(os==='ios'?'Ios':'And')];if(v.getAttribute('src')!==src)v.setAttribute('src',src);}
    ov?.classList.add('open');v?.play().catch(()=>{});
  }));
  $('ct-v5-modal-close')?.addEventListener('click',close);
  ov?.addEventListener('click',e=>{if(e.target===ov)close();});
}

function init(){
  /* Judge.me hides its widget behind a style its own JS removes; unreliable on page templates. */
  ROOT.querySelectorAll('.ct-v5-reviews-jdgm .jdgm-temp-hiding-style').forEach(el=>el.remove());
  ROOT.querySelectorAll('[data-os-set]').forEach(b=>b.addEventListener('click',()=>setOS(b.dataset.osSet,true)));
  ROOT.querySelectorAll('[data-lang-set]').forEach(b=>b.addEventListener('click',()=>setLang(b.dataset.langSet)));
  ROOT.querySelectorAll('[data-os-flip]').forEach(b=>b.addEventListener('click',()=>setOS(os==='ios'?'and':'ios',true)));
  ROOT.querySelectorAll('a[href="#ct-v5-buy"]').forEach(a=>a.addEventListener('click',e=>{
    const buy=$('ct-v5-buy');if(!buy)return;e.preventDefault();buy.scrollIntoView({behavior:'smooth',block:'start'});
  }));
  buildColorGrid('ct-v5-sil-grid',SIL_COLORS,silQtys);
  buildColorGrid('ct-v5-col-grid',COL_COLORS,colQtys);
  initBattery();
  $('ct-v5-atc-btn')?.addEventListener('click',addToCart);
  $('ct-v5-sticky-atc-btn')?.addEventListener('click',addToCart);
  initFAQ();initModal();initCarouselControls();
  setOS(os,false);
  const bar=$('ct-v5-sticky-atc'),buy=$('ct-v5-buy');
  if(bar&&buy&&'IntersectionObserver' in window){
    new IntersectionObserver(([e])=>bar.classList.toggle('hidden',e.isIntersecting||e.boundingClientRect.top>0&&window.scrollY<200),{threshold:0.1}).observe(buy);
  }
}
document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();
})();
